import React from "react"
import { Breadcrumb } from "@components/anti/Breadcrumb"
import { Cover } from "@components/anti/Cover"
import { translations } from "src/helper/translations"

export default function ContactCover({ data, locale }) {
  return (
    <section className="sc-contact-cover">
      <Cover
        img="/img/bg/img_bg-contact-cover-mobile.png"
        imgMd="/img/bg/img_bg-contact-cover.png"
        imgHeight="h-250px h-md-400px"
        title={data && data[`title_${locale}`]}
        titleClassName="contact-title"
        text=""
        breadcrumb={
          <Breadcrumb
            path={`/${translations[`contact_us_${locale}`]}`}
            theme="dark"
          />
        }
      />
    </section>
  )
}
